/* واجهة بوّابة المؤسّسة (Supabase). بعد الدخول ينكشف نظامك القديم. */
import Loader from "./Loader.jsx";
import Signup from "./Signup.jsx";
import Landing from "./Landing.jsx";
import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { useSupaAuth } from "./supaAuth.jsx";
import { hasSupabaseKeys } from "./supabaseClient.js";

function NoKeys() {
  return (
    <div className="ag-screen"><div className="ag-card">
      <div className="ag-title">إعداد ناقص</div>
      <div className="ag-sub">مفاتيح Supabase غير موجودة</div>
      <div className="ag-hint" style={{ textAlign: "right", lineHeight: 2 }}>
        أنشئ ملفّ <b dir="ltr">.env.local</b> وأضف VITE_SUPABASE_URL و VITE_SUPABASE_ANON_KEY، ثمّ أعد التشغيل.
      </div>
    </div></div>
  );
}

function AuthScreen() {
  const { signIn, signUpManager } = useSupaAuth();
  const [mode, setMode] = useState("login");
  const [fullName, setFullName] = useState("");
  const [orgName, setOrgName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(""); const [msg, setMsg] = useState(""); const [busy, setBusy] = useState(false);
  const go = async () => {
    setErr(""); setMsg("");
    if (!email.trim() || !password) { setErr("أكمل البريد وكلمة المرور."); return; }
    setBusy(true);
    try {
      if (mode === "login") {
        try { window.__tpmsJustLoggedIn = true; } catch {}
        const e = await signIn(email, password);
        if (e) { setErr(e); try { window.__tpmsJustLoggedIn = false; } catch {} }
        else {
          try {
            const { supabase } = await import("./supabaseClient.js");
            const { data: u } = await supabase.auth.getUser();
            const uid = u && u.user && u.user.id;
            if (uid) {
              const ua = navigator.userAgent || "";
              const browser = /CriOS|Chrome/.test(ua) ? "Chrome" : /Firefox|FxiOS/.test(ua) ? "Firefox" : /Edg/.test(ua) ? "Edge" : /Safari/.test(ua) ? "Safari" : "متصفح آخر";
              const os = /iPhone|iPad/.test(ua) ? "iOS" : /Android/.test(ua) ? "Android" : /Mac/.test(ua) ? "macOS" : /Win/.test(ua) ? "Windows" : "نظام آخر";
              const device = /Mobi|iPhone|Android/.test(ua) ? "جوال" : /iPad|Tablet/.test(ua) ? "لوحي" : "حاسوب";
              const { error: slErr } = await supabase.from("session_log").insert({ profile_id: uid, device, browser, os });
              import("./errorlog.js").then((m) => { if (m.logError) m.logError(slErr ? ("فشل تسجيل الجلسة: " + slErr.message) : ("جلسة سجلت بنجاح: " + device + " " + browser)); });
            }
          } catch (e2) { try { import("./errorlog.js").then((m) => { if (m.logError) m.logError("استثناء التسجيل: " + ((e2 && e2.message) || e2)); }); } catch {} }
        }
      }
      else {
        if (!fullName.trim() || !orgName.trim()) { setErr("أكمل الاسم واسم المؤسّسة."); setBusy(false); return; }
        const r = await signUpManager(fullName, orgName, email, password);
        if (r.err) setErr(r.err);
        else if (r.needConfirm) setMsg("أُنشئ الحساب. أكّد البريد ثمّ سجّل الدخول. (للتطوير: عطّل تأكيد البريد في Supabase.)");
      }
    } finally { setBusy(false); }
  };
  return (
    <div className="ag-screen"><div className="ag-card">
      <img src="/logo.png?v=2" alt="" style={{ width: 74, height: 74, borderRadius: 18, margin: "0 auto 10px", display: "block" }} /><div className="ag-title">نظام إدارة مشاريع ترجمة</div>
      <div className="ag-sub">{mode === "login" ? "دخول المؤسّسة" : "حساب مؤسّسة جديدة (المدير)"}</div>
      {mode === "signup" && (<>
        <label className="ag-label">اسم المدير</label>
        <input className="ag-input" value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="مثال: دلال نصرالله" />
        <label className="ag-label">اسم المؤسّسة</label>
        <input className="ag-input" value={orgName} onChange={(e) => setOrgName(e.target.value)} placeholder="مثال: ترجمتك" />
      </>)}
      <label className="ag-label">البريد الإلكتروني</label>
      <input className="ag-input" type="email" dir="ltr" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && go()} />
      <label className="ag-label">كلمة المرور</label>
      <input className="ag-input" type="password" dir="ltr" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && go()} />
      {err && <div className="ag-err">{err}</div>}
      {msg && <div className="ag-shown">{msg}</div>}
      <button className="ag-btn ag-btn-primary" onClick={go} disabled={busy}>{busy ? "…" : mode === "login" ? "دخول" : "إنشاء المؤسّسة"}</button>
      <button className="ag-link" onClick={() => { setMode(mode === "login" ? "signup" : "login"); setErr(""); setMsg(""); }}>
        {mode === "login" ? "مؤسّسة جديدة؟ أنشئ حسابًا" : "لديك مؤسّسة؟ سجّل الدخول"}
      </button>
      <div className="ag-hint">هذه بوّابة المؤسّسة السحابية. بعد الدخول ينشئ المدير الأعضاء من داخل المنصة.</div>
    </div></div>
  );
}

function CompleteSetup() {
  const { completeSetup, signOut } = useSupaAuth();
  const [fullName, setFullName] = useState(""); const [orgName, setOrgName] = useState("");
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const go = async () => {
    setErr(""); if (!fullName.trim() || !orgName.trim()) { setErr("أكمل الحقلين."); return; }
    setBusy(true); const e = await completeSetup(fullName, orgName); setBusy(false); if (e) setErr(e);
  };
  return (
    <div className="ag-screen"><div className="ag-card">
      <div className="ag-title">إكمال الإعداد</div>
      <div className="ag-sub">لننشئ مؤسّستك</div>
      <label className="ag-label">اسم المدير</label>
      <input className="ag-input" value={fullName} onChange={(e) => setFullName(e.target.value)} />
      <label className="ag-label">اسم المؤسّسة</label>
      <input className="ag-input" value={orgName} onChange={(e) => setOrgName(e.target.value)} />
      {err && <div className="ag-err">{err}</div>}
      <button className="ag-btn ag-btn-primary" onClick={go} disabled={busy}>{busy ? "…" : "متابعة"}</button>
      <button className="ag-link" onClick={signOut}>تسجيل الخروج</button>
    </div></div>
  );
}

export default function OrgGate({ children }) {
  const { session, profile, loading, needSetup } = useSupaAuth();
  const routeOf = () => /^\/(login|loging)\/?$/.test(location.pathname) ? "auth" : (/^\/signup\/?$/.test(location.pathname) ? "signup" : "home");
  const [route, setRoute] = React.useState(routeOf);
  const go = (r) => { setRoute(r); try { history.pushState({}, "", r === "auth" ? "/login" : r === "signup" ? "/signup" : "/"); } catch {} };
  const showAuth = route === "auth";
  React.useEffect(() => {
    const onPop = () => setRoute(routeOf());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  const [minShow, setMinShow] = React.useState(false);
  React.useEffect(() => {
    if (session && typeof window !== "undefined" && window.__tpmsJustLoggedIn) {
      window.__tpmsJustLoggedIn = false;
      setMinShow(true);
      const t = setTimeout(() => setMinShow(false), 2800);
      return () => clearTimeout(t);
    }
  }, [session]);
  if (!hasSupabaseKeys) return <NoKeys />;
  if (loading && !minShow) return null;
  if (minShow) return <div className="ag-screen"><div className="ag-card" style={{ textAlign: "center" }}><style>{`@keyframes tpmsType { 0% { width: 0; } 70%, 100% { width: 100%; } }`}</style><div style={{ display: "inline-block", overflow: "hidden", whiteSpace: "nowrap", animation: "tpmsType 2.4s steps(34) 1 both", maxWidth: "100%" }}><span className="ag-sub">ثوانٍ من فضلك لتحميل قاعدة البيانات…</span></div></div></div>;
  if (!loading && session && !profile && !needSetup) return <div className="ag-screen"><div className="ag-card" style={{ textAlign: "center" }}><div style={{ fontSize: 15, fontWeight: 800, color: "var(--text)", marginBottom: 8 }}>تعذر فتح المؤسّسة</div><div className="ag-sub" style={{ marginBottom: 16 }}>يرجى التحقق من الاتصال ثم إعادة المحاولة.</div><div style={{ display: "flex", gap: 10, justifyContent: "center" }}><button className="ag-btn" onClick={() => location.reload()}>إعادة المحاولة</button></div></div></div>;
  if (!session) return showAuth ? <AuthScreen /> : route === "signup" ? <Signup onLogin={() => go("auth")} onHome={() => go("home")} /> : <Landing onLogin={() => go("auth")} onPricing={() => go("signup")} />;
  if (needSetup || !profile) return <CompleteSetup />;
  return children;
}
